<template>
    <!--
    :loading = "loading"   最大的loading
          :treeLoading ="tree_loading"    树的loading
          :tableLoading ="tableLoading"    表格的loading
          :treedata="treedata"           树的data
          :saveShow = "saveShow"         是否现实保存按钮
          :componentData="componentData"   tabs的展示
          :resultData="resultData"          右边的选中展示值
          @on-select-tree="selectTtree"     树的选中事件
          @on-change-tree="changeTtree"     树的change事件
          @on-click-tab="clickTab"          tab 的点击事件
          @on-change-page="changePage"       分页的点击事件
          @on-change-pageSize="changePageSize"  分页页码的点击事件
          @on-row-dblclick="rowdbclick"          表格的双击事件
          @on-row-click="rowclick"               表格的单击事件
          @on-search="inputsearch"               查询框的查询事件
          @on-checkbox-change="checkboxChange"   排除按钮的事件
          @on-transfer-two="transfertwo"         穿梭 双头 的点击事件
          @on-transfer="transfer"                穿梭 单头 的点击事件
          @on-delectli="deleteLi"              选中li的 删除事件
          @on-refresh="refreshFun"             重新 刷新事件
          @on-saveBtn="saveBtn"                 保存模板事件
          @on-deleBtn="deleBtn"                  全部清空事件
    -->
    <div class="dialog">
        <Complexs-dialog
          ref="dialogtest"  
          :loading = "loading"
          :treedata="treedata"
          :saveShow = "saveShow"
          :componentData="componentData"
          :resultData="resultData"
          @on-select-tree="selectTtree"
          @on-change-tree="changeTtree"
          @on-click-tab="clickTab"
          @on-change-page="changePage"
          @on-change-pageSize="changePageSize"
          @on-row-dblclick="rowdbclick"
          @on-row-click="rowclick"
          @on-search="inputsearch"
          @on-checkbox-change="checkboxChange"
          @on-transfer-two="transfertwo"
          @on-transfer="transfer"
          @on-delectli="deleteLi"
          @on-refresh="refreshFun"
          @on-saveBtn="saveBtn"
          @on-deleBtn="deleBtn"
        >

        </Complexs-dialog>
    </div>
</template>
<script>
import { TreeData, TableData, selectDate } from '../mock/fkdata';

export default {
  data() {
    return {
      treedata: [], //tree data
      loading: false, // z最大loading
      tree_loading: true, // 左边的 的loading
      tableLoading: true, // 中间的 的loading
      componentData: [
        {
          tab: '筛选结果',
          columns: [], // 表格头部
          list: [], // 表格底部
          tableprops:{
            tabindex:true,
            ctrlAdd:(obj)=>{
                console.log('ctrlAdd',obj);
            },
            shiftAdd:(obj)=>{
                console.log('shiftAdd',obj);
            }
          },
          tablevent:{

          },
          search: '', // 查询值
          pageOptions: [10, 20, 50, 100],
          height: 200, // 表格行高
          searchName: '全局检索',
          checked: false
        },
        {
          tab: '查看选中结果',
          columns: [],
          list: [],
          height: 200,
          search: '',
          searchName: '查询结果'
        }
      ],
      resultData: {
        total: 10,
        list: [
          // item.string 显示的文字
        ]
      }, // 选中结果
      open: false, // 是否打开
      IN: [], // 选中id
      NOTIN: [], // 不选中id
      refresh: false, // 刷新
      saveShow: false, // 是否展示保存模板
      checked: false
    };
  },
  methods: {
    getData() {
      this.loading = false;

      this.treeRestructure();
      this.dateRestructure();
    },
    treeRestructure() {
      // tree_lists 树形结构重新组合
      this.tree_loading = false;
      this.treedata = TreeData.data.map(obj => {
        let option = {};
        option.title = obj.NAME;
        option.expand = !!obj.expand;
        option.children = [...obj.VALUE];
        option.children.forEach(item => {
          item.title = item.NAME;
        });
        return option;
      });
    },
    dateRestructure() {
      // 表格数据的 重新组合
      let tableData = TableData.data;
      this.componentData[0] = Object.assign(
        this.componentData[0],
        TableData.data
      );
      this.resultData.list = selectDate.data.list.map(item => {
        item.string = item.MIXNAME;
        return item;
      });
      this.resultData.total = selectDate.data.total;
      let header = JSON.parse(TableData.header);
      this.componentData[0].columns = this.columnsDate(header);
      this.componentData[0].columns.unshift({
        type: 'index',
        width: 60,
        fixed: 'left',
        align: 'center',
        indexMethod(row) {
          return row._index;
        }
      });
      this.componentData[1].columns = this.columnsDate(header);
      this.componentData[1] = Object.assign(
        this.componentData[1],
        selectDate.data
      );
    },
    columnsDate(columns) {
      // 表格头部 数据重组
      return Object.keys(columns).reduce((item, option) => {
        item.push({
          key: option,
          title: columns[option]
        });
        return item;
      }, []);
    },
    selectTtree(obj, vm) {
      console.log(obj, vm);
    },
    changeTtree(obj, vm) {
      console.log(obj, vm);
    },
    clickTab(index, vm) {
      console.log(index, vm);
    },
    changePage(index, vm) {
      let option = this.componentData[0].list.map(item => {
        item.ENAME = item.ENAME + Math.random().toFixed(3);
        return item;
      });
      this.componentData[0].list = Object.assign(option, {});
      console.log(index, vm);
    },
    changePageSize(index, vm) {
      console.log(index, vm);
    },
    rowdbclick(row, index, vm) {
      console.log('rowdbClick');

      if (this.checked) {
        // if(!this.NOTIN.some((x)=>{ return x=== row.ID})){
        //     this.NOTIN.push(row.ID);
        // }else{
        //     this.$Message.info('选中状态已经存在');
        // }

        console.log(this.valivalue(this.NOTIN, row.ID), 'jiayao');
      }
    },
    valivalue(arr, id) {
      if (!arr.some(x => x === id)) {
        return true;
      } else {
        return false;
      }
    },
    rowclick(index, row, vm) {
      console.log('rowclick');

      //console.log(index,row,vm);
    },
    inputsearch(event, vm) {
      console.log(event, vm);
    },
    checkboxChange(value, vm) {
      this.checked = value;
      //console.log(value,vm);
    },
    transfertwo(vm) {
      console.log(vm);
    },
    transfer(vm) {
      console.log(vm);
    },
    deleteLi(index, tem) {
      console.log(index, tem);
    },
    deleBtn(vm) {
      console.log(vm);
    },
    saveBtn(value, vm) {
      console.log(value, vm);
    },
    refreshFun(vm) {
      console.log(vm);
    }
  },
  computed: {},
  mounted() {
    this.getData();
    /**/
  },
  created() {}
};
</script>




// WEBPACK FOOTER //
// examples/routers/fkdialog.vue